export default __webpack_public_path__ + "static/A33000kmwalkfromhumansbirthplace-aea9d0aebe472929826d30c0373b8fe6.jpg";